import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import layoutContext from "./layoutContext";
import { OutVector, Logo } from "../assets/svg/index";
import { useSelector } from "react-redux";
import SidebarDropDown from "../components/common/SidebarDropDown";
import ConfirmationModel from "../components/common/ConfirmationModel";

const Sidebar = () => {
  const { isAsideOpen } = useContext(layoutContext);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { getProfileData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
  }));

  const logOutClear = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <aside
        className={`${
          isAsideOpen ? "w-64" : "w-0 md:w-20"
        } fixed md:relative z-50 top-0 left-0 bg-white border-r border-gray-200 transition-all duration-300 h-[calc(100vh-4rem)] flex flex-col justify-between`}
      >
        {/* Logo */}
        <div className="flex items-center justify-center px-4 py-3 border-b border-gray-200 bg-navTheme">
          <div
            className={`cursor-pointer flex justify-center items-center ${
              isAsideOpen ? "w-48 h-16" : "w-12 h-12"
            } transition-all duration-300`}
            onClick={() => navigate("/")}
          >
            <Logo />
          </div>
        </div>

        {/* Menu Items */}
        <ul
          className={`flex-1 overflow-x-hidden ${
            isAsideOpen ? "overflow-y-auto" : "overflow-visible"
          }`}
        >
          {getProfileData?.permission_list
            ?.filter((menu) => menu?.is_show !== 0)
            .map((menu, index) => {
              const filteredSubMenu = menu?.subMenu?.filter(
                (sub) => sub?.is_show !== 0
              );

              if (filteredSubMenu?.length) {
                return (
                  <SidebarDropDown
                    key={index}
                    isAsideOpen={isAsideOpen}
                    menu={{ ...menu, subMenu: filteredSubMenu }}
                  />
                );
              }

              return (
                <li key={index} className="group aside-links tooltipBlock">
                  <button
                    className={`flex items-center relative z-[99999] m-0 ${
                      !isAsideOpen
                        ? "px-2 hover:translate-x-0 hover:bg-light_secondary_shades my-1 justify-center"
                        : "hover:translate-x-1 px-4 "
                    }  py-2 gap-x-4 h-auto hover:text-black w-full rounded-lg transition duration-200  ${
                      location.pathname ===
                        `/${menu.path === "dashboard" ? "" : menu?.path}` &&
                      `bg-light_secondary_shades`
                    }`}
                    onClick={() => {
                      navigate(
                        `${menu?.path === "dashboard" ? "/" : menu?.path}`
                      );
                    }}
                  >
                    <div className="max-w-5 max-h-5 w-full">
                      <img
                        src={menu?.icon_path ?? Logo}
                        className="w-full h-full object-contain"
                        alt="icon"
                      />
                    </div>
                    <div>
                      <p
                        className={`origin-left font-normal duration-250 flex items-center text-left text-base font-Proxima ${
                          !isAsideOpen && "hidden"
                        }`}
                      >
                        {menu.title}
                      </p>
                      <p
                        className={`origin-left font-extralight duration-250 flex items-center text-left text-sm font-Proxima ${
                          !isAsideOpen && "hidden"
                        }`}
                      >
                        {menu.sub_title}
                      </p>
                    </div>
                    {!isAsideOpen && (
                      <div
                        id="tooltip"
                        className="right absolute top-[20%] left-[55px] text-xs whitespace-nowrap font-semibold -z-[100] hidden"
                      >
                        <div className="absolute w-0 h-0 border-transparent border-solid tooltip-arrow border-r-transparent" />
                        <div className="tooltip-label py-1 px-2 text-white bg-black rounded-[4px] text-center max-w-[180px] text-base font-Proxima">
                          {menu.title}
                        </div>
                      </div>
                    )}
                  </button>
                </li>
              );
            })}
        </ul>

        {/* Log Out */}
        <div className="p-4 border-t border-gray-200">
          <button
            className={`flex items-center w-full rounded-lg transition-all duration-200 hover:text-black ${
              isAsideOpen ? "px-4 gap-x-4" : "px-2 justify-center"
            } hover:bg-light_secondary_shades`}
            onClick={() => setIsLogoutModalOpen(true)}
          >
            <OutVector />
            {isAsideOpen && (
              <p className="font-medium text-base font-Proxima">Log Out</p>
            )}
          </button>
        </div>
      </aside>

      {/* Logout Confirmation Modal */}
      {isLogoutModalOpen && (
        <ConfirmationModel
          onConfirm={() => {
            logOutClear();
            setIsLogoutModalOpen(false);
          }}
          onClose={() => setIsLogoutModalOpen(false)}
          confirmText="Logout"
        />
      )}
    </>
  );
};

export default Sidebar;
